import Campanas from "./Campanas";

export default Campanas;
